import { useDataSubmit, useDataValue } from 'Simple/Data.js'
export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'new_patient',
    viewPath: props.viewPath,
  })
  let lead_id = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'id',
  })
  return function onClick() {
    submit({ lead_id, add_patient_to_lead: true })
  }
}
